<template>
  <div class="moreInfo">
    <!-- 背景图片 -->
    <div class="font">
      <!-- 头部 -->
      <div class="header">
        <img
          @click="back"
          class="label2"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng055f7822a065d24838fe4f8316b496c62564a3c880241121ac9014c59d7218c3"
        />
        <!-- 背景文字 -->
        <div class="dregdes">
          <img src="../../assets/img/more/more-wenzi.png" alt="" />
        </div>
      </div>
      <!-- 中间部分 -->
      <div class="main">
        <!-- 中间标题 -->
        <div class="title">
          <img src="../../assets/img/more/more-quanyi.png" alt="" />
        </div>
        <!-- flex布局排版 -->
        <div class="overall">
          <div class="all">
            <img src="../../assets/img/more/more-set.png" alt="" />
            <div class="setting">随时随地管理账户查询明细</div>
          </div>
          <div class="all">
            <img src="../../assets/img/more/more-into.png" alt="" />
            <div class="setting">提现0手续费秒级到账</div>
          </div>
          <div class="all">
            <img src="../../assets/img/more/more-safe.png" alt="" />
            <div class="setting">平安银行保障资金安全</div>
          </div>
          <div class="all">
            <img src="../../assets/img/more/more-nigger.png" alt="" />
            <div class="setting">权威机构认证保护隐私</div>
          </div>
          <div class="all">
            <img src="../../assets/img/more/more-personal.png" alt="" />
            <div class="setting">个人税务资料登记合法合规</div>
          </div>
          <div class="all">
            <img src="../../assets/img/more/more-set.png" alt="" />
            <div class="setting">随时随地管理账户 查询明细</div>
          </div>
        </div>
        <!-- 继续开通按钮 -->
        <button class="mod2 flex-col" @click="onClick_1">
          <span class="word4">继续开通</span>
        </button>
        <div class="footer" @click="checkName">放弃权益，只进行实名</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted(){

  },
  methods: {
    // 返回上一层
    back() {
      this.$router.go(-1); //返回上一层
    },
    // 继续开通按钮
    onClick_1() {
      // this.$router.push({path:"/commonInfo",query:{type:2}}) // 取消二类户开通入口
      this.$router.push({path:"/commonInfo",query:{type:1}})
    },
    checkName(){
      this.$router.push({path:"/commonInfo",query:{type:1}})
    }
  },
};
</script>

<style lang="less" scoped>
.moreInfo {
  width: 750px;
  height: 100%;
  // 背景图片
  .font {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/more/more-bj.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .label2 {
      width: 16px;
      height: 27px;
      margin-top: 20px;
      margin-left: -85%;
    }
    .dregdes {
      z-index: 10;
      margin-top: 30px;
      img {
        width: 536px;
        height: 174px;
      }
    }
    // 中间部分
    .main {
      margin-left: 20px;
      margin-right: 20px;
      height: 910px;
      background-color: #fff;
      border-radius: 10px;
      margin-top: 130px;
      position: relative;
      // 标题
      .title img {
        width: 382px;
        height: 73px;
        position: absolute;
        left: 25%;
        top: -15px;
      }
      // 布局排版
      .overall {
        padding: 0 50px 0px 50px;
        display: flex;
        flex-wrap: wrap;
        .all {
          font-size: 24px;
          width: 190px;
          height: 308px;
          margin-right: 10px;
          margin-top: -10px;
          .setting {
            text-align: center;
          }
          img {
            width: 145px;
            height: 140px;
            margin-top: 124px;
          }
        }
      }
      // 继续开通按钮
      .flex-col {
        display: flex;
        flex-direction: column;
      }
      .mod2 {
        width: 80%;
        z-index: 105;
        height: 90px;
        border-radius: 45px;
        background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4ba68295ce88d3ea8387f4f9197214ff3f04a3fd100f5ef03bfa50979df64c06)
          100% no-repeat;
        align-self: center;
        margin-top: 100px;
        margin-left: 10%;
        justify-content: center;
        align-items: center;
        border:none;
        .word4 {
          z-index: 106;
          width: 150px;
          display: block;
          overflow-wrap: break-word;
          color: rgba(95, 61, 16, 1);
          font-size: 34px;
          letter-spacing: 1px;
          font-family: PingFangSC-Medium;
          line-height: 48px;
          text-align: center;
        }
      }
      .footer{
        color:#666666;
        font-size: 26px;
        margin-top:40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/moreInfo/index.vue